const getBusinessCityStateZip = ({ business, value }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  if (business && business['Company Address'] && business['Company Address'].ID) {
    return `${business['Company Address'].City}, ${business['Company Address'].State} ${business['Company Address']['Zip Code']}`.toUpperCase();
  }
  return null;
};

export default getBusinessCityStateZip;



// WEBPACK FOOTER //
// ./src/utils/print/getBusinessCityStateZip.js